import React, { Component } from 'react';

import { HomeSlider, HomeTitle, Img,
  CoverSection,
  ResponsiveYouTubeIframe     } from '../../Components/UI/UI';

import { getWeather, isMobile } from '../../Utility/Utility';

import Menu from '../../Components/Menu/Menu';
import Footer from '../../Components/Footer/Footer';

import './CoronaVirus.css';

class CoronaVirus extends Component {
  state = {
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  componentDidMount() {
    getWeather((Weather) => {
      console.log('Weather', Weather);
      this.setState({
        telAvivWeather: Weather.telAvivWeather,
        waterTemp: Weather.water_temp,
        jerusalemWeather: Weather.jerusalemWeather,
      });
    });
  }

  render() {
    return (
      <div className="page align-left page-Corona-virus">
        <Menu />
        {!isMobile() ?  <CoverSection desktopImg={'/HomeSlider/corona.jpg'} mobileImg={'/HomeSlider/M/uk/4.jpg'} cssClass={'north'} waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather}/>: <div className="ac-corona-mobile-video"><ResponsiveYouTubeIframe vidId={'yE5MV_10cZw'}/></div>} 
            
        <div className="container">
             
             <div className="ac-new-container">
             <div className="ac-new-container">
 <h2 className="ac-pink"></h2>
 <h2 className="ac-pink ac-pink ac-margin-top-1 ac-bigger">Welcome back!</h2>
 <h2><span><strong>Israel Travelling guidelines for fully vaccinated foreign nationals</strong></span></h2><br/>
 <p className="ac-align-left-15">As of November 1, 2021, foreign nationals qualifying as fully vaccinated will be allowed to enter Israel subject to the following terms and conditions:</p>
 <ul>
    <li>- You were not present in a red country during the 14 days prior to entering Israel.</li>
    <li>- You are vaccinated with a WHO approved vaccine, subject to the conditions set out below.</li>
    <li>- Entrance to Israel is via Ben Gurion Airport only.</li>
    <li>- There is no other impediment to your entering Israel.</li>
    <li>- Foreign nationals who do not meet the above conditions may still apply to enter Israel through the <a href="https://survey.gov.il/he/PCR2" target="_blank" rel="noopener">Exceptions Committee</a></li>
 </ul>
 <h2 className="ac-pink">Recognized Vaccines</h2><br/>
 <p className="ac-align-left-15">The following vaccines are approved by Israel: Moderna, Pfizer, Johnson &amp; Johnson – Janssen, AstraZeneca, Covishield, Sinopharm, Sinovac, SputniK-V (subject to the terms and conditions below)</p>
 <br/>
 <p className="ac-align-left-15"><strong>Who does Israel recognize as fully vaccinated? </strong></p>
 
 <p className="ac-align-left-15">Foreign nationals vaccinated with Pfizer / Moderna / AstraZeneca / Sinovac or Sinopharm:</p>
 <ul>
    <li>- If you have completed a course of two vaccine shots then upon entry to Israel, at least 14 days must have passed since you received your second vaccine shot (but no more than 180 days upon leaving Israel).</li>
    <li>- If you have received a booster shot, then upon entry to Israel, at least 14 days must have passed since you received your booster shot.</li>
 </ul>
 &nbsp;
 
 <p className="ac-align-left-15">Foreign nationals vaccinated with the Johnson &amp; Johnson – Janssen vaccine:</p>
 <ul>
    <li>- At least 14 days must have passed since your vaccination date (but no more than 180 days upon leaving Israel).</li>
    <li>- If you have received a booster dose then upon entry to Israel, at least 14 days must have passed since you received your booster shot.</li>
 </ul>
 &nbsp;
 
 <p className="ac-align-left-15">Foreign nationals vaccinated with the Sputnik vaccine:</p>
 <ul>
    <li>- Foreign nationals vaccinated with the Sputnik vaccine, as of 15.11.21, and who have tested positive in a serological COVID antibody test taken in Israel (You must remain in isolation until a positive result is obtained).</li>
    <li>- You must have completed a course of two vaccine doses, and upon entry to Israel at least 14 days must have passed since you received your second vaccine shot (but no more than 180 days upon leaving Israel).</li>
    <li>- If you have received a booster dose then upon entry to Israel, at least 14 days must have passed since you received your booster shot.</li>
 </ul>
 <h2><strong>Entrance to Israel for persons fully recovered from COVID*</strong></h2><br/>
 <p className="ac-align-left-15">Foreign nationals who have recovered from COVID will be allowed to enter Israel if they possess a digital certificate that can be authenticated by Israeli Ministry of Health Systems and based on a positive result in a NAAT test (molecular test similar to PCR).</p>
 <ul>
    <li>- Upon entry to Israel at least 11 days must have passed since the positive test result (but no more than 190 days upon departure from Israel)</li>
    <li>- You must have received at least one dose of a WHO-approved vaccine (there is no significance to the order of events).</li>
 </ul>
 <a href="#_ednref1" name="_edn1"></a>
 
 <b>* Entry for recoverees is only applicable for those coming from countries that issue certificates that the Israeli MOH systems can digitally authenticate, which is not available for people traveling from the USA or Canada</b>
 
 <h2><strong>The process of entering Israel</strong></h2>
 <br/>
 <ul className="ac-wrpr-num">
    <li className="ac-num-li">1. You must perform a PCR test up to 72 hours before your flight</li>
    <li className="ac-num-li">2. You must fill out a passenger declaration before entering Israel.
 <ul>
    <li>- Passengers holding a verifiable digital certificate should scan or upload their immunization or recovery certificate to the incoming passenger form and will receive a green pass before boarding the plane.</li>
    <li>- Passengers who do not have a verifiable digital certificate will declare their vaccination status in the incoming passenger form and fill out an application to shorten the isolation period. Then, they will attach the relevant documents to receive a green pass before boarding the plane.</li>
 </ul>
 </li>
    <li className="ac-num-li">3. When boarding the plane, the following documents must be presented
 <ul>
    <li>- Documentation of a negative PCR test performed up to 72 hours before the flight.</li>
    <li>- Confirmation of submission of an incoming passenger declaration.</li>
    <li>- Vaccination certificate attesting to the performance of vaccinations in accordance with the provisions above.</li>
    <li>- Certificate of recovery, the Israeli MOH systems can digitally authenticate, indicating a recovery in accordance with the provisions set above.</li>
    <li>- A digital certificate attesting to recovery from COVID in accordance with the provisions above.</li>
    <li>-Exceptional entry permit from the Israeli Ministry of the Interior (Exceptions, Outline, Groups)</li>
 </ul>
 </li>
    <li className="ac-num-li">4. Random document compliance tests will be conducted by the Population Authority at Ben Gurion Airport.</li>
    <li className="ac-num-li">5. A PCR test must be taken upon landing at Ben Gurion Airport. You will have to enter isolation until a negative result is obtained, or for 24 hours, whichever is earlier.</li>
    <li className="ac-num-li">6. Travellers vaccinated with Sputnik vaccines must perform a serological test at Ben Gurion Airport and enter isolation until a positive test result is obtained (In addition to isolation until a negative result is obtained for the PCR test taken upon landing).</li>
 </ul>
 <br/>
 <p className="ac-align-center">For the list of countries that issue certificates that the Israeli MOH systems can digitally authenticate:<br/>
 <a href="https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en" target="_blank" rel="noopener" className="ac-align-center">https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en</a></p><br/>
 <p  className="ac-align-center">For the full entry protocol details click here:<br/>
 <a href="https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air"  className="ac-align-left-15" target="_blank" rel="noopener">https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air</a></p><br/>
 <p  className="ac-align-center"><strong><span>The above-mentioned guidelines are detailed here for your information and convenience. If and when in doubt, please refer to the guidelines published on the Israeli Ministry of Health site as the information there is the most recent and accurate.</span>
 </strong><br/> <a href="https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air"  className="ac-align-center" target="_blank" rel="noopener">https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air</a></p>
 
 <h2 className="ac-pink">See you soon!</h2>
 
 </div>
 
 <div className="ac-inner-video">
   <ResponsiveYouTubeIframe vidId={'LSb4Lmuw_Kw'}/>
 </div>
 </div>
 
           </div>
 
 
           
         <Footer />
       </div>
    );
  }
}

export default CoronaVirus;



// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirus.js